import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { Alert, Spinner } from 'react-bootstrap'
import axiosInstance from '../services/axiosInterceptor'
import OfficialDocLayout from './print/OfficialDocLayout'
import { fmtDateTHFull } from './aoShared'

// พิมพ์หนังสือราชการภายนอกจากเนื้อหาที่ร่างไว้ใน out_body
export default function OutgoingDocPrint() {
  const { outId } = useParams()
  const [doc, setDoc] = useState(null)
  const [error, setError] = useState('')

  useEffect(() => {
    axiosInstance.get(`/api/ao/outgoing/${outId}`)
      .then(res => { if (res.data.success) setDoc(res.data.data) })
      .catch(err => setError(err.response?.data?.message || 'โหลดข้อมูลไม่สำเร็จ'))
  }, [outId])

  if (error) return <div className="p-4"><Alert variant="danger">{error}</Alert></div>
  if (!doc) return <div className="text-center py-5"><Spinner animation="border" variant="primary" /></div>

  return (
    <OfficialDocLayout docNo={doc.out_full_no} backLink="/admin-office/outgoing">
      <div style={{ marginTop: 12 }}>วันที่ {fmtDateTHFull(doc.out_doc_date)}</div>
      <div style={{ marginTop: 8 }}>เรื่อง&nbsp;&nbsp;{doc.out_subject}</div>
      <div>เรียน&nbsp;&nbsp;{doc.out_to}</div>

      {doc.out_body ? (
        <div className="doc-body" style={{ marginTop: 12 }}
          dangerouslySetInnerHTML={{ __html: doc.out_body }} />
      ) : (
        <div className="text-muted" style={{ marginTop: 12 }}>
          — ยังไม่ได้ร่างเนื้อหนังสือ (แก้ไขได้ที่ทะเบียนหนังสือส่ง) —
        </div>
      )}

      <div className="doc-sign" style={{ marginLeft: '50%' }}>
        <div>ขอแสดงความนับถือ</div>
        <div style={{ marginTop: 60 }}>({doc.out_signer || '....................................'})</div>
        <div>ผู้อำนวยการโรงเรียน</div>
      </div>
    </OfficialDocLayout>
  )
}
